import {mapGetters, mapActions, mapMutations} from 'vuex'
import moment from 'moment'

export default {

    data: () => {
      return {
          labLastTrainingDate_: ''
      }
    },

    computed: {

        laboratoryId() {
            return this.$route.params.laboratoryId;
        },

        ...mapGetters('laboratories', [
            'laboratories',
            'laboratory',
            'laboratoriesTrainingInfo'
        ]),

        laboratoryType() {
            return this.laboratory?.laboratoriesType?.name || '';
        },

        laboratoryUsers() {
            return this.laboratory?.users || []
        },

        laboratoryLevelOfServices() {
            return this.laboratory?.levelOfServices ? this.laboratory.levelOfServices.split(', ') : []

        },

        labLastTrainingDate() {
            if (this.labLastTrainingDate_) {
                let days = Math.round(moment.duration(moment().startOf('day') - this.labLastTrainingDate_).asDays());
                return `${days} ${this.$t('days')} ${this.$t('ago')}`;
            }
            return '';
        }

    },

    methods: {

        ...mapActions('laboratories', {
            getOneLab: 'getOne',
            getByCountry: 'getByCountry',
            updateLaboratory: 'update'
        }),

        ...mapMutations('laboratories', [
            'setLaboratory'
        ]),

        ...mapMutations([
            'setGlobalLoading'
        ]),

        showUserData(item) {
            return `${item.firstName || ''} ${item.lastName || ''}`
        },

        async getCurrentLaboratory() {
            try {
                this.setGlobalLoading(true);
                await this.getOneLab(this.laboratoryId)
            } catch(e) {
                console.error(e)
            } finally {
                this.setGlobalLoading(false);
            }
        },

        async getLaboratoriesByCountry(countryId) {
            try {
                this.setGlobalLoading(true);
                await this.getByCountry(countryId)
            } catch(e) {
                console.error(e)
            } finally {
                this.setGlobalLoading(false);
            }
        },

        userHasAccessToLaboratory() {
            // TODO: add access check
            // TODO: redirect to has not access page
            return true;

            // if (this.meSuperAdmin || (this.meLaboratoryId === this.laboratoryId)) {
            //     return true
            // }
            //
            // if (window.history.length > 2) {
            //     this.$router.back();
            // } else {
            //     this.$router.push('/');
            // }
            //
            // return false
        },


        generateTrainingData(user) {
            let userSessions = [...user.userToSession];

            userSessions.sort((a, b) => {
                return b.createdAt - a.createdAt;
            });

            let sessionData = [];

            for (let session of userSessions) {
                let sessionId = session?.session;
                if (!sessionId) {
                    continue;
                }

                let trSession = this.findSession(sessionId);


                let trModule = this.findModule(trSession.trainingModule);

                if(!trModule) {
                    continue
                }

                let sessionMetadata = this.findLaboratoryNameFromMetadataBySession(user.metadata, sessionId);
                if (!sessionMetadata) {
                    continue;
                }

                let labName = sessionMetadata.laboratoryName;

                let date = moment(trSession.dateRange.split(', ')[1]) || null;

                if (!this.labLastTrainingDate_) {
                    this.labLastTrainingDate_ = date
                } else {
                    if (this.labLastTrainingDate_.isBefore(date)) {
                        this.labLastTrainingDate_ = date
                    }
                }

                sessionData.push({
                    date,
                    labName,
                    trainingModuleName: trModule.name,
                })
            }

            return sessionData
        },

        findSession(sessionId) {
            return this.laboratory.trainingSessions.find(e => e.id === sessionId)
        },

        findModule(moduleId) {
            return this.laboratory.trainingModules.find(e => e.id === moduleId)
        },

        findLaboratoryNameFromMetadataBySession(metadata, sessionId) {
            if (!('training' in metadata)) {
                return false
            }
            return metadata.training.find(e => e.trainingSessionId == sessionId);
        }
    }
}
